import './App.css';
import {
    Route,
    createBrowserRouter,
    createRoutesFromElements
} from "react-router-dom";
import Login from './login/';
import ProtectedLayout from './protectedLayout'
import NotFound from './notFound';
import UserPlans from './userPlans';
import CreateNewUser  from './userPlans/createNew/';
import UserPlanDetails from './userPlans/planDetails/';
import Users from './users';
import UserEdit from './users/editUser';
import UserPlanReactivation from './userPlans/reactivatePlan';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route>
                <Route element={<ProtectedLayout page={<UserPlans/>} title={'Benutzerpläne'}/>} path="/user-plans"/>
                <Route element={<ProtectedLayout page={<CreateNewUser/>}
                                                 title={'Benutzer erstellen und Plan zuweisen'}/>}
                       path="/create-new-user"/>

                <Route element={<ProtectedLayout page={<UserPlanDetails/>}
                                                 title={'Details zum Benutzerplan'}/>}
                       path="/user-plans/details/:id"/>

                <Route element={<ProtectedLayout page={<Users/>}
                                                 title={'Benutzer'}/>}
                       path="/users"/>
                <Route element={<ProtectedLayout page={<UserEdit/>}
                                                 title={'Benutzer bearbeiten'}/>}
                       path="/users/:id/edit"/>
                <Route element={<ProtectedLayout page={<UserPlanReactivation/>}
                                                 title={'Neuen Benutzerplan hinzufügen'}/>}
                       path="/user-plans/new/:id/edit"/>
            </Route>
            <Route element={<Login/>} path="/"/>
            <Route path="*" element={<ProtectedLayout page={<NotFound/>}/>}/>
        </Route>
    )
);

